<template>
  <UiAlert
    type="warning"
    icon="common/timer"
    :button-text="$tc('notificationPanel.limitsGo')"
    :text="alertText"
    :align-center="full"
    :full-size="full"
    is-button
    @button="goToLimits"
  />
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'SetLimits',
  props: {
    full: { type: Boolean, default: false },
  },
  computed: {
    alertText() {
      return this.$tc(
        this.full
          ? 'notificationPanel.limitsMessage'
          : 'notificationPanel.limitsMessageShort'
      )
    },
  },
  methods: {
    ...mapActions('globalModal', ['open_limitsModalBeforeGame']),
    goToLimits() {
      this.open_limitsModalBeforeGame(false)
    },
  },
}
</script>
